/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import makeAnimated from 'react-select/animated'
import * as Yup from 'yup'
import axios from 'axios'
import Swal from 'sweetalert2'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../styles/styles'
import {useQueryClient} from 'react-query'
import withReactContent from 'sweetalert2-react-content'
import {Input3} from '../../../../../../components/Forms/Input'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {
  IPropertyParticipations,
  propertyParticipationsInitValues as initialValues,
} from '../../../property/models/PropertiesModel'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  propertiesParticipations: any
}
const propertiesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalEditePropertyParticipation: React.FC<Props> = ({
  show,
  handleClose,
  id,
  propertiesParticipations,
}) => {
  const intl = useIntl()
  const animatedComponents = makeAnimated()
  const [loading, setLoading] = useState(false)
  const [owners, setOwners] = useState([])
  const queryClient = useQueryClient()
  const [isCheckedBeneficiary, setIsCheckedBeneficiary] = useState<boolean>()

  const handleOnChangeBeneficiary = () => {
    setIsCheckedBeneficiary(!isCheckedBeneficiary)
    formik.setFieldValue('beneficiary', isCheckedBeneficiary)
  }

  useEffect(() => {
    insertInitialValues(propertiesParticipations)
  }, [])

  async function insertInitialValues(data: any) {
    const PropertyParticipations: IPropertyParticipations = await data
    console.log('PropertyParticipations', PropertyParticipations)
    if (PropertyParticipations.uuid) {
      formik.setFieldValue('uuid', PropertyParticipations.uuid || '')
    }
    if (PropertyParticipations.property_id) {
      formik.setFieldValue('property_id', PropertyParticipations.property_id || '')
    }
    if (PropertyParticipations.percentage) {
      formik.setFieldValue('percentage', PropertyParticipations.percentage || '')
    }

    if (PropertyParticipations.beneficiary != null) {
      formik.setFieldValue('beneficiary', PropertyParticipations.beneficiary)
      console.log('beneficiary', PropertyParticipations.beneficiary)
      setIsCheckedBeneficiary(PropertyParticipations.beneficiary)
    }

    if (PropertyParticipations.owner_id) {
      formik.setFieldValue('owner_id', PropertyParticipations.owner_id)
    }
    if (PropertyParticipations.owner) {
      setTimeout(() => {
        let ownerArray: any = []
        if (PropertyParticipations.owner) {
          ownerArray.push({
            value: PropertyParticipations.owner.id,
            label: PropertyParticipations.owner.name,
          })
        }
        setOwners(ownerArray)
      }, 5000)
    }
  }

  const loadOptionsOwners = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getOwners()
      let owners: any = []
      async function getOwners() {
        const {data} = await axios.get(API_URL + '/sgt/v1/owners/select2')
        let Response = data.results
        if (Response) {
          for (const element of Response) {
            const owner: any = {
              value: element.id,
              label: element.name,
            }
            owners.push(owner)
          }
        }
      }
      callback(owners)
    }, 1000)
  }

  const handleInputChangeOwners = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    setOwners(event)
    formik.setFieldValue('owner_id', inputValue)
    return {inputValue}
  }

  const formik = useFormik<IPropertyParticipations>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      console.log('values', values)
      try {
        await axios.put(
          `${API_URL}/sgt/v1/property_participations/${propertiesParticipations.uuid}`,
          values
        )
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'OWNER.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('property-participations-page=1&items_per_page=10')
        handleClose()
        formik.resetForm()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'OWNER.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        formik.resetForm()
        handleClose()
      }
    },
  })

  function deleteMsgLicense() {
    const MySwal = withReactContent(Swal)

    MySwal.fire({
      title: intl.formatMessage({id: 'PROPERTIES.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (propertiesParticipations.uuid !== undefined) deleteProperties()
      }
    })
  }

  async function deleteProperties() {
    try {
      await axios.delete(
        `${API_URL}/sgt/v1/property_participations/${propertiesParticipations.uuid}`
      )
      Swal.fire({
        icon: 'success',
        title: intl.formatMessage({id: 'OWNER.SWAL_DELETE'}),
        showConfirmButton: false,
        timer: 2000,
      })
      queryClient.invalidateQueries('property-participations-page=1&items_per_page=10')
      handleClose()
      formik.resetForm()
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'OWNER.SWAL_DELETE_ERROR'}),
        showConfirmButton: false,
        timer: 1500,
      })
      handleClose()
    }
  }

  const closeModal = () => {
    handleClose()
    formik.resetForm()
    insertInitialValues(propertiesParticipations)
  }
  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={closeModal}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>{intl.formatMessage({id: 'OWNERS.PARTICIPATION'})}</span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={closeModal}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* INICIO NOME PROPRIEDADE */}
                  <input
                    type='text'
                    className='d-none form-control-lg form-control-solid mb-3 mb-lg-0'
                    // placeholder={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                  />
                  {formik.touched.property_id && formik.errors.property_id && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.property_id}</div>
                    </div>
                  )}

                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'OWNERS.TITLE'})}
                    </label>

                    <div className='row'>
                      <AsyncSelect
                        className='form-control form-control-lg form-control-solid p-1 ps-3'
                        styles={colourStyles}
                        components={animatedComponents}
                        value={owners}
                        cacheOptions
                        loadOptions={loadOptionsOwners}
                        filterOption={(option, inputValue) =>
                          option.label
                            ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                            : false
                        }
                        defaultOptions
                        onChange={handleInputChangeOwners}
                        placeholder={intl.formatMessage({
                          id: 'OWNER.TITLE',
                        })}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                          },
                        })}
                      />
                      {/* FIM NOME PROPRIEDADE */}

                      {/* INICIO NOME PORCENTAGEM */}

                      <Input3
                        title={intl.formatMessage({id: 'COMMON.INPUT_PERCENTEGE'})}
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_PERCENTEGE'})}
                        {...formik.getFieldProps('percentage')}
                      />

                      {/* FIM NOME PORCENTAGEM */}
                      <label className='form-label fs-6 fw-bold d-flex mt-3 required'>
                        {intl.formatMessage({id: 'OWNER.BENEFICIARY'})}
                      </label>
                      <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                        <label className='form-check-label'>
                          {intl.formatMessage({id: 'COMMON.NO'})}
                          &nbsp;
                        </label>
                        <input
                          className='form-check-input w-45px h-30px'
                          type='checkbox'
                          id='allowmarketing'
                          {...formik.getFieldProps('beneficiary')}
                          onChange={() => {
                            console.log('beneficiary isCheckedBeneficiary', isCheckedBeneficiary)
                          }}
                          onClick={handleOnChangeBeneficiary}
                          checked={isCheckedBeneficiary}
                        />
                        <label className='form-check-label'>
                          {intl.formatMessage({id: 'COMMON.YES'})}
                        </label>
                      </div>
                    </div>

                    {/* Submit */}
                    <div className='d-flex justify-content-between mt-3 py-6'>
                      <button
                        id='kt_delete_property_participation'
                        type='button'
                        className='btn btn-sm btn-light-danger fw-bold'
                        onClick={deleteMsgLicense}
                      >
                        {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
                      </button>
                      <button type='submit' className='btn btn-primary' disabled={loading}>
                        {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                        {loading && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                    {/* ----------------------------------------------------------------------------------- */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalEditePropertyParticipation}
